import React, { useState, useEffect } from "react";
import { Col, Pagination, Modal, Button, message, Select, Descriptions } from "antd";
import SearchBar from "../searchbar/SearchBar";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavItem } from "../nav/NavContext";

const ApplicationList = ({ data, reload }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [smallScreen, setSmallScreen] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  const { token } = useSelector((state) => state.auth);
  const [currentFilterValue, setCurrentFilterValue] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { setSelectedItem, selectedItem } = useNavItem();

  const totalPages = Math.ceil(filteredData.length / pageSize);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1168) {
        setSmallScreen(true);
        setPageSize(7);
      } else {
        setSmallScreen(false);
        setPageSize(10);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (data && data.applications) {
      console.log(data)
      let newData = [...data.applications];
      
      // Apply filter
      if (currentFilterValue === 1) {
        newData.sort((a, b) => a.business_name.localeCompare(b.business_name));
      } else if (currentFilterValue === 2) {
        newData.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      } else if (currentFilterValue === 3) {
        newData.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      }

      // Apply search filter
      const filtered = newData.filter((application) =>
        application?.business_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        application?.email?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      console.log(filtered)

      setFilteredData(filtered);
    } else if (data && Array.isArray(data)) {
      // Handle case where data is directly an array
      let newData = [...data];
      
      // Apply filter
      if (currentFilterValue === 1) {
        newData.sort((a, b) => a.business_name.localeCompare(b.business_name));
      } else if (currentFilterValue === 2) {
        newData.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      } else if (currentFilterValue === 3) {
        newData.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      }

      // Apply search filter
      const filtered = newData.filter((application) =>
        application?.business_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        application?.email?.toLowerCase().includes(searchQuery.toLowerCase())
      );

      setFilteredData(filtered);
    } else {
      setFilteredData([]);
    }
  }, [data, searchQuery, currentFilterValue]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    setCurrentPageData(filteredData.slice(startIndex, endIndex));
  }, [filteredData, currentPage, pageSize]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (value) => {
    if (value === 1) {
      setPageSize(10);
    } else if (value === 2) {
      setPageSize(20);
    } else if (value === 3) {
      setPageSize(30);
    }
    setCurrentPage(1);
  };

  const handleFilterChange = (value) => {
    setCurrentFilterValue(value);
    setCurrentPage(1);
  };

  const handleViewClick = async (application) => {
    try {
      const response = await axios.get(
        `https://altablue.cloud/api/applications/${application.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.status === 200 && response?.data?.success) {
        console.log(response.data.data)
        setSelectedApplication(response.data.data);
        setIsViewModalVisible(true);
      }
    } catch (error) {
      message.error("Failed to fetch application details!");
    }
  };

  const handleDeleteClick = (application) => {
    setSelectedApplication(application);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await axios.delete(
        `https://altablue.cloud/api/applications/${selectedApplication.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response?.status === 200 && response?.data?.success) {
        message.success("Application deleted successfully");
        reload();
        setIsDeleteModalVisible(false);
        setSelectedApplication(null);
      }
    } catch (error) {
      message.error("Failed to delete application!");
    }
  };

  const handleViewModalClose = () => {
    setIsViewModalVisible(false);
    setSelectedApplication(null);
  };

  const handleDeleteModalClose = () => {
    setIsDeleteModalVisible(false);
    setSelectedApplication(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return '#52c41a';
      case 'rejected':
        return '#ff4d4f';
      case 'under_review':
        return '#faad14';
      case 'pending':
      default:
        return '#1890ff';
    }
  };

  return (
    <div className="companyDetailsection">
      <Col span={24}>
        <div
          className="companyDetailsProperty"
          style={
            !smallScreen
              ? {
                  width: "100%",
                  // height: "93vh",
                }
              : {
                  width: "100%",
                  // height: "93vh",
                }
          }
        >
          <div className="companyDetailsNavbar">
            <h3>All Applications</h3>
            {/* <div></div>
            <div className="dropdownsWrapper">
              <Select
                value={currentFilterValue}
                style={{
                  width: 180,
                  marginRight: "12px",
                }}
                onChange={handleFilterChange}
                options={[
                  {
                    value: 1,
                    label: "Alphabetical Order",
                  },
                  {
                    value: 2,
                    label: "Oldest to Newest",
                  },
                  {
                    value: 3,
                    label: "Newest to Oldest",
                  },
                ]}
              />

              <Select
                defaultValue={1}
                style={{
                  width: 120,
                }}
                onChange={handlePerPageChange}
                options={[
                  {
                    value: 1,
                    label: "10 per page",
                  },
                  {
                    value: 2,
                    label: "20 per page",
                  },
                  {
                    value: 3,
                    label: "30 per page",
                  },
                ]}
              />
            </div> */}
          </div>

          {/* <SearchBar
            value={searchQuery}
            placeholder="Search by business name or email..."
            onChange={(value) => {
              setSearchQuery(value);
              setCurrentPage(1);
            }}
          /> */}

          <div className="companyHeadingNav">
            <div className={!smallScreen ? "applicationNavSmall" : "applicationNav"}>
              <div>Business Name</div>
              <div>Date Established</div>
              <div>Address</div>
              <div>Phone Number</div>
              <div>Email Address</div>
              <div>Owners</div>
              <div>Modify</div>
              {/* {smallScreen && <div>Modify</div>} */}
            </div>
            <div className="">
              {currentPageData.map((application, index) => (
                <div
                  style={
                    !smallScreen && index % 2 !== 0
                      ? {
                          backgroundColor: "#e8ffff",
                        }
                      : {}
                  }
                  className="mainData"
                  key={application.id}
                >
                  <div
                    className={
                      !smallScreen
                        ? "applicationHeadingBodySmall"
                        : "applicationHeadingBody"
                    }
                  >
                    <div>{application.business_name || "N/A"}</div>
                    <div>{formatDate(application.date_established)}</div>
                    <div>
                      {application.street_address && application.city
                        ? `${application.street_address}, ${application.city}`
                        : "N/A"}
                    </div>
                    <div>{application.phone_number || "N/A"}</div>
                    <div>{application.email || "N/A"}</div>
                    <div>{application.owner_names || "N/A"}</div>
                    {smallScreen && (
                      <div className="center editButtons">
                        <button
                          className="editButton"
                          onClick={() => handleViewClick(application)}
                        >
                          View
                        </button>
                        <Button
                          className="deleteButton"
                          onClick={() => handleDeleteClick(application)}
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                    {!smallScreen && (
                      <div className="center editButtons">
                        <button
                          className="editButton"
                          onClick={() => handleViewClick(application)}
                        >
                          View
                        </button>
                        <button
                          className="deleteButton"
                          onClick={() => handleDeleteClick(application)}
                        >
                          Delete
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="pagination">
            <Pagination
              current={currentPage}
              total={filteredData.length}
              pageSize={pageSize}
              onChange={handlePageChange}
              showSizeChanger={false}
              showQuickJumper={false}
              showTotal={(total, range) =>
                `Showing ${range[0]} to ${range[1]} of ${total} entries`
              }
            />
          </div>
        </div>
      </Col>

      {/* View Application Modal */}
      <Modal
        title="Application Details"
        visible={isViewModalVisible}
        onCancel={handleViewModalClose}
        footer={[
          <Button key="close" onClick={handleViewModalClose}>
            Close
          </Button>,
        ]}
        width={800}
      >
        {selectedApplication && (
          
          <div>
            <Descriptions bordered column={2} size="small">
              <Descriptions.Item label="Business Name" span={2}>
                {selectedApplication.business_name}
              </Descriptions.Item>
              <Descriptions.Item label="Date Established">
                {formatDate(selectedApplication.date_established)}
              </Descriptions.Item>
              {/* <Descriptions.Item label="Status">
                <span style={{ color: getStatusColor(selectedApplication.status) }}>
                  {selectedApplication.status?.toUpperCase()}
                </span>
              </Descriptions.Item> */}
              <Descriptions.Item label="Email">
                {selectedApplication.email}
              </Descriptions.Item>
              <Descriptions.Item label="Phone Number">
                {selectedApplication.phone_number}
              </Descriptions.Item>
              <Descriptions.Item label="Address" span={2}>
                {`${selectedApplication.street_address || ''}, ${selectedApplication.city || ''}, ${selectedApplication.state_province_region || ''} ${selectedApplication.zip_postal_code || ''}, ${selectedApplication.country || ''}`}
              </Descriptions.Item>
              <Descriptions.Item label="Federal ID">
                {selectedApplication.federal_id_number}
              </Descriptions.Item>
              <Descriptions.Item label="DOT Number">
                {selectedApplication.mc_number}
              </Descriptions.Item>
              <Descriptions.Item label="Type of Ownership">
                {selectedApplication.type_ownership}
              </Descriptions.Item>
              <Descriptions.Item label="State Registered">
                {selectedApplication.state_registered}
              </Descriptions.Item>
              <Descriptions.Item label="Number of Trucks">
                {selectedApplication.number_of_trucks}
              </Descriptions.Item>
              <Descriptions.Item label="Average Monthly Sales">
                ${selectedApplication.average_monthly_sales?.toLocaleString()}
              </Descriptions.Item>
              <Descriptions.Item label="Monthly Factor Amount">
                ${selectedApplication.monthly_factor_amount?.toLocaleString()}
              </Descriptions.Item>
              <Descriptions.Item label="Terms of Sales">
                {selectedApplication.terms_of_sales}
              </Descriptions.Item>
              {selectedApplication.notes && (
                <Descriptions.Item label="Notes" span={2}>
                  {selectedApplication.notes}
                </Descriptions.Item>
              )}
            </Descriptions>

            {selectedApplication.owners && selectedApplication.owners.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <h3>Owners Information</h3>
                {selectedApplication.owners.map((owner, index) => (
                  <Descriptions
                    key={owner.id}
                    bordered
                    column={2}
                    size="small"
                    title={`Owner ${index + 1}`}
                    style={{ marginTop: 10 }}
                  >
                    <Descriptions.Item label="Name">
                      {owner.owner_name}
                    </Descriptions.Item>
                    <Descriptions.Item label="Title">
                      {owner.title}
                    </Descriptions.Item>
                    <Descriptions.Item label="Percentage Owned">
                      {owner.percentage_owned}%
                    </Descriptions.Item>
                    <Descriptions.Item label="SSN">
                      {owner.ssn || 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Address" span={2}>
                      {`${owner.street_address || ''}, ${owner.city || ''}, ${owner.state_province_region || ''} ${owner.zip_postal_code || ''}, ${owner.country || ''}`}
                    </Descriptions.Item>
                    <Descriptions.Item label="Cell Phone">
                      {owner.cell_phone || 'N/A'}
                    </Descriptions.Item>
                    {index === 0 && (
                      <Descriptions.Item label="Referral Name">
                        {owner.referral_name || 'N/A'}
                      </Descriptions.Item>
                    )}
                    {index !== 0 && <Descriptions.Item label="">&nbsp;</Descriptions.Item>}
                  </Descriptions>
                ))}
              </div>
            )}
          </div>
        )}
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        title="Confirm Delete"
        visible={isDeleteModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={handleDeleteModalClose}
        okText="Delete"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
      >
        <p>
          Are you sure you want to delete the application for{" "}
          <strong>{selectedApplication?.business_name}</strong>? This action cannot be undone.
        </p>
      </Modal>
    </div>
  );
};

export default ApplicationList;